export default {"src":"/_next/static/media/baby7.f9fa9720.svg","height":210,"width":210,"blurWidth":0,"blurHeight":0};